export var RANGE_VALUE = 'range';
export var RANGE_TYPE = 'type';
export var PERCENT = 'percent';
export var DEFAULT_COLOR = '#f0f0f0';
/** 仪表盘由 指针和表盘 组成 */
export var INDICATEOR_VIEW_ID = 'indicator-view';
export var RANGE_VIEW_ID = 'range-view';
//# sourceMappingURL=constant.js.map